import type { HeadingProps } from "@chakra-ui/react";

const capitalizedHeading: HeadingProps = {
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
};

export { capitalizedHeading };
